const state = {
    activeCompany: []
}
  
const getters = {
    activeCompany: state => state.activeCompany,
}
  
const actions = {
    async setCompany({ commit }, company) {
        commit('SET_COMPANY', company)
    },
}
  
const mutations = {
    SET_COMPANY: (state, company) => {
        state.activeCompany = company
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
  